<template>
  <div class="article-detail" v-loading="loading">
    <article v-if="article" class="detail-content">
      <header class="article-header">
        <div class="article-header-meta">
          <span class="article-tag" v-if="article.category">{{ article.category.name }}</span>
        </div>
        <h1 class="article-title">{{ article.title }}</h1>
        <div class="article-meta-bottom">
          <span class="article-date" v-if="article.published_at || article.created_at">
            {{ formatDate(article.published_at || article.created_at) }}
          </span>
          <span class="article-views">{{ article.view_count }} 次浏览</span>
        </div>
      </header>
      <div class="article-body">
        <MarkdownRenderer :content="article.content_md" />
      </div>
      <div class="article-footer-tags" v-if="article.tags && article.tags.length">
        <span class="footer-tag-label">标签</span>
        <span class="footer-tag" v-for="tag in article.tags" :key="tag.id">{{ tag.name }}</span>
      </div>
    </article>
    <el-empty v-else-if="!loading" description="文章不存在" />
  </div>
</template>

<script>
import MarkdownRenderer from '../../components/MarkdownRenderer.vue'
import { frontApi } from '../../utils/api'

export default {
  name: 'ArticleDetail',
  components: { MarkdownRenderer },
  data() { return { article: null, loading: false, viewStartTime: null, viewRecordId: null } },
  created() { this.loadArticle() },
  mounted() { this.viewStartTime = Date.now() },
  beforeDestroy() { this.reportViewDuration() },
  watch: { '$route.params.slug'() { this.reportViewDuration(); this.loadArticle() } },
  methods: {
    async loadArticle() {
      this.loading = true
      try { const res = await frontApi.getArticle(this.$route.params.slug); this.article = res.article; this.viewStartTime = Date.now(); this.recordView(this.article.id) } catch (e) { console.error(e) }
      this.loading = false
    },
    async recordView(articleId) {
      try { const res = await frontApi.recordView({ path: window.location.pathname, article_id: articleId }); this.viewRecordId = res.id } catch (e) { /* silent */ }
    },
    reportViewDuration() {
      if (this.viewStartTime && this.viewRecordId) {
        const duration = Math.round((Date.now() - this.viewStartTime) / 1000)
        const data = JSON.stringify({ path: window.location.pathname, article_id: this.article ? this.article.id : null, visit_duration: duration })
        const baseUrl = process.env.VUE_APP_API_URL || ''
        if (navigator.sendBeacon) { navigator.sendBeacon(baseUrl + '/api/view-record', data) }
      }
    },
    formatDate(dateStr) {
      if (!dateStr) return ''
      const d = new Date(dateStr)
      return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`
    }
  }
}
</script>

<style scoped>
.article-detail { max-width: 42rem; margin: 0 auto; padding: 3rem 1.5rem 5rem; background: var(--blog-bg); }
.article-header { margin-bottom: 3rem; }
.article-header-meta { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; flex-wrap: wrap; }
.article-tag { font-family: var(--font-mono); font-size: 0.7rem; color: var(--blog-accent); background: var(--blog-accent-subtle); padding: 0.15rem 0.6rem; border-radius: 1rem; text-transform: uppercase; letter-spacing: 0.04em; }
.article-date, .article-views { font-size: 0.85rem; color: var(--blog-text-3); }
.article-meta-bottom { display: flex; align-items: center; gap: 1rem; margin-bottom: 1.25rem; }
.article-title { font-family: var(--font-display); font-size: clamp(1.8rem, 4vw, 2.5rem); font-weight: 700; line-height: 1.2; color: var(--blog-text); letter-spacing: -0.02em; margin-bottom: 0.5rem; }
.article-body { font-size: 1.05rem; line-height: 1.75; color: var(--blog-text); }
.article-footer-tags { margin-top: 2.5rem; padding-top: 2rem; border-top: 1px solid var(--blog-border); display: flex; align-items: center; gap: 0.6rem; flex-wrap: wrap; }
.footer-tag-label { font-family: var(--font-mono); font-size: 0.75rem; color: var(--blog-text-3); text-transform: uppercase; letter-spacing: 0.06em; }
.footer-tag { font-family: var(--font-mono); font-size: 0.7rem; color: var(--blog-text-2); background: var(--blog-bg-secondary); padding: 0.2rem 0.6rem; border-radius: 1rem; border: 1px solid var(--blog-border); }
</style>
